import { FC } from "react";
import { OperatorChatMessageContainer } from "./styles";

const OperatorChatMessage: FC<{ value: string; }> = ({ value }) => (
  <OperatorChatMessageContainer>
    <span />
    <p>{value}</p>
    <span />
  </OperatorChatMessageContainer>
)

export  default OperatorChatMessage;
